import React, { useEffect, useState } from 'react';
import AddToGroupForm from './AddToGroupForm';
import FormTable from './FormTable';
import api from '../../../../../api';
import { useParams } from 'react-router';

const FormTab = ({ classes }) => {
    const { id: groupId } = useParams();
    const [forms, setForms] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(true);
    const loadForms = () => {
        setLoading(true);
        api.forms
            .all()
            .then((results) => {
                console.log(results);
                setForms(results);
                setFilteredData(getFormsByGroupId(results));
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
    };

    const addtoGroupList = (item) => {
        setFilteredData([...filteredData, item]);
    };

    useEffect(() => {
        loadForms();
    }, []);

    const getFormsByGroupId = (list) =>
        list.filter((item) => item.groups.includes(groupId));

    const removeFromGroup = (id) => {
        api.groups
            .removeResource('forms', groupId, id)
            .then(() => {
                const list = filteredData.filter((item) => item._id !== id);
                setFilteredData(list);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    return (
        <>
            <FormTable
                removeFromGroup={removeFromGroup}
                classes={classes}
                filteredData={filteredData}
                loading={loading}
            />
            <AddToGroupForm addtoGroupList={addtoGroupList} forms={forms} />
        </>
    );
};

export default FormTab;
